import { Checkbox, FormControlLabel, FormHelperText, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";
import { Controller } from "react-hook-form";

import {
  buildFieldIds,
  getNestedError,
  hasNonEmptyDescription,
  type SchemaFieldProps,
} from "./utils";

export function BooleanField({
  fieldKey,
  property,
  fieldPath,
  isRequired,
  control,
  errors,
}: SchemaFieldProps) {
  const errorMessage = getNestedError(errors, fieldPath);
  const { description } = property;
  const hasDescription = hasNonEmptyDescription(description);
  const { describedBy } = buildFieldIds(fieldPath, hasDescription);

  return (
    <Controller
      name={fieldPath}
      control={control}
      rules={
        isRequired
          ? {
              validate: {
                required: (value: unknown) =>
                  typeof value === "boolean" || "This field is required",
              },
            }
          : undefined
      }
      defaultValue={false}
      render={({ field }) => (
        <Stack spacing={0.5}>
          <FormControlLabel
            style={{ marginLeft: "-9px" }}
            label={
              <>
                {fieldKey}
                {isRequired ? " *" : ""}
              </>
            }
            control={
              <Checkbox
                inputRef={field.ref}
                checked={Boolean(field.value)}
                inputProps={{ "aria-describedby": describedBy, name: field.name }}
                onBlur={field.onBlur}
                onChange={(event) => {
                  field.onChange(event.target.checked);
                }}
              />
            }
          />
          {hasDescription && (
            <Text
              id={describedBy}
              variant="body2"
              sx={(theme) => ({
                color: theme.palette.text.secondary,
                fontWeight: theme.typography.fontWeightRegular,
                fontSize: "0.875rem",
                lineHeight: 1.5,
              })}
            >
              {description}
            </Text>
          )}
          {errorMessage ? <FormHelperText error>{errorMessage}</FormHelperText> : null}
        </Stack>
      )}
    />
  );
}
